/**
 * Ryan O'Dowd
 * 2025-03-21
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Button from '@components/common/Button';
import React from 'react';
import {
  followUser,
} from '@utils/store/actions';
import getStyles from './styles';
import hooks from '@hooks';

const User = (props: UserProps) => {
  const dispatch = hooks.useTypedDispatch();
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  const isLoading = hooks.useTypedSelector((state: any) => state.loadingStates.followUser?.userId === props.userIdToFollow);

  return (
    <Button
      mode='contained'
      icon='account-plus'
      disabled={isLoading}// @TODO: needs to be more optimistic than this...or maybe this isn't working
      loading={isLoading}
      theme={styles.colors.accent}
      onPress={() => dispatch(followUser(props.userIdToFollow))}
    >
      {i18n('follow')}
    </Button>
  );
};

class UserProps {
  userIdToFollow: number;
};

export default User;
